module.exports = __webpack_public_path__ + "img/CCAPPLOGO.2a00e349.png";